import { render, staticRenderFns } from "./DesktopSerpFilters.vue?vue&type=template&id=6bd7b2c0&scoped=true&"
import script from "./DesktopSerpFilters.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DesktopSerpFilters.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DesktopSerpFilters.vue?vue&type=style&index=0&id=6bd7b2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd7b2c0",
  null
  
)

export default component.exports